import { FormEvent, useState } from 'react'
import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cnjDigits, isValidCnj, maskCnj } from '@/lib/cnj'
import { importacoesService } from '@/services/importacoes-service'
import { apiErrorMessage } from '@/services/team-service'
import * as toast from '@/lib/toast'

interface AddProcessMonitorFormProps {
  onAdded: () => void
}

/** Cadastra um processo para monitorar pelo número CNJ (com dígito verificador conferido). */
export function AddProcessMonitorForm({ onAdded }: AddProcessMonitorFormProps) {
  const [value, setValue] = useState('')
  const [busy, setBusy] = useState(false)
  const digits = cnjDigits(value)
  const invalid = digits.length === 20 && !isValidCnj(value)
  const ready = isValidCnj(value)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    if (!ready) return
    setBusy(true)
    try {
      await importacoesService.addProcess(digits)
      toast.success('Processo monitorado', maskCnj(digits))
      setValue('')
      onAdded()
    } catch (error) {
      toast.error(apiErrorMessage(error, 'Não foi possível cadastrar o processo'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-1">
      <div className="flex gap-2">
        <Input
          aria-label="Número do processo (CNJ)"
          placeholder="0000000-00.0000.0.00.0000"
          inputMode="numeric"
          value={value}
          aria-invalid={invalid || undefined}
          onChange={(e) => setValue(maskCnj(e.target.value))}
          className="sm:w-72"
        />
        <Button type="submit" disabled={!ready || busy}><Plus /> Monitorar</Button>
      </div>
      {invalid && <p role="alert" className="text-xs text-destructive">Número inválido: o dígito verificador não confere.</p>}
    </form>
  )
}
